<nav class="navbar navbar-icon-top navbar-expand-lg navbar-light navbar-custom" *ngIf="!shouldHideHeader()">
  <a class="navbar-brand" routerLink="/">

    <img [src]="logo" class="vid-logo ms-3" alt="">
  </a>

  <button class="navbar-toggler collapsed mb-2" type="button"
          data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav me-auto">
      <li *ngIf="showApplicationsHeader && navbarService.identity" class="nav-item" routerLinkActive
          #rla2="routerLinkActive">
        <a class="nav-link" routerLink="applications">
          <img
            src="{{rla2.isActive ? 'assets/navigation/app-selected@2x.png' : 'assets/navigation/app@2x.png'}}"/>
          <span [ngClass]="{'selected-label': rla0.isActive}">{{ 'HEADER.APPLICATIONS' | translate }}</span>
        </a>
      </li>
      <li *ngIf="navbarService.identity" class="nav-item" routerLinkActive #rla1="routerLinkActive">
        <a class="nav-link" routerLink="authenticators">
          <img
            src="{{rla1.isActive ? 'assets/navigation/cyber-security (1)-1@2x.png' : 'assets/navigation/cyber-security (1)@2x.png'}}"/>
          <span [ngClass]="{'selected-label': rla1.isActive}">{{ 'HEADER.AUTHENTICATORS' | translate }}</span>
        </a>
      </li>
      <li *ngIf="navbarService.identity" class="nav-item" routerLinkActive #rla2="routerLinkActive">
        <a class="nav-link" routerLink="sessions">
          <img
            src="{{rla2.isActive ? 'assets/navigation/sheet-1@2x.png' : 'assets/navigation/sheet@2x.png'}}"/>
          <span [ngClass]="{'selected-label': rla2.isActive}">{{ 'HEADER.ACTIVITY' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive #rla0="routerLinkActive">
        <a (click)="onEnrollment()" class="nav-link" style="cursor: pointer;">
          <img src="assets/navigation/021-security.png"/>
          <span [ngClass]="{'selected-label': rla0.isActive}">{{ 'HEADER.ENROLLMENT' | translate }}</span>
        </a>
      </li>
      <li *ngIf="navbarService.identity" class="nav-item" routerLinkActive #rla4="routerLinkActive">
        <a class="nav-link" routerLink="identity">
          <img
            src="{{rla4.isActive ? 'assets/navigation/login-1@2x.png' : 'assets/navigation/login@2x.png' }}"/>
          <span [ngClass]="{'selected-label': rla4.isActive}">{{ navbarService.identity.displayName }}</span>
        </a>
      </li>
    </ul>
    <ul class="navbar-nav me-3">
      <li class="nav-item">
        <div class="vid-h1">Self-Service Portal</div>
        <div class="text-end me-2">
          <select class="form-select form-select-sm vid-language-selector" id="languageSelect"
                  name="languageSelect" [(ngModel)]="navbarService.language" (change)="onChangeLang($event)">
            <option *ngFor="let lang of translate.getLangs()" [ngValue]="lang">{{ lang }}</option>
          </select>
          <button id="logoutBtn1" *ngIf="staticResourcesService.isI18nConfigFetched && navbarService.identity"
                  (click)="redirectService.redirectToSAMLLogout()" type="button"
                  class="float-end vid-btn vid-btn-orange vid-btn-sm me-2 logout-btn">{{ 'IDENTITY.LOGOUT' | translate }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</nav>
